@use '../../../styles/Constants.scss' as Constants;
@use '../../../styles/Colors.scss' as Colors;

$val-search-field-width: 250px;

@mixin icon {
	position: absolute;
	right: Constants.$val-spacing-s;
	font-size: Constants.$val-fontSizeBig;
	color: Colors.$col-greyFontLight;
}

.action-header {
	display: flex;
	flex-direction: column;
	padding: Constants.$val-spacing-m Constants.$val-spacing-l;
	border-bottom: 1px solid Colors.$col-greyConnection;
	background-color: Colors.$col-greyLight;
	justify-content: space-between;
	flex-direction: column;

	&__additional-filters-container {
		display: flex;
		justify-content: space-between;
		flex-direction: row;
	}

	&__filters {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		width: -webkit-fill-available;

		&__search-input {
			position: relative;
			display: flex;
			align-items: center;
			margin-right: Constants.$val-spacing-m;
			height: Constants.$val-inputHeight;

			& > input {
				height: 100%;
				width: $val-search-field-width !important;
				min-width: Constants.$val-textFilterMinWidth;
				border: 1px solid Colors.$col-greyMid;
				border-radius: Constants.$val-borderRadius;

				&::placeholder {
					color: Colors.$col-greyFontLight;
				}

				&[placeholder*="by"] {
					min-width: 160px;
				}
			}

			& > [class^="icon-search"] {
				@include icon;
				top: Constants.$val-spacing-s;
			}

			> a > [class^="icon-close"] {
				@include icon;
				right: Constants.$val-spacing-s;
				top: 50%;
				transform: translateY(-50%);
			}

			&--stretch {
				flex: 1;
			}

			&--bulk {
				position: relative;
		
				& > [class^="icon-search"] {
					@include icon;
					left: Constants.$val-spacing-s;
					width: fit-content;
					top: 50%;
					transform: translateY(-50%);
				}


				> a > [class^="icon-close"] {
					@include icon;
					left: Constants.$val-spacing-s;
					top: 50%;
					transform: translateY(-50%);
				}
		
				> a > [class^="icon-filter"] {
					@include icon;
					top: 50%;
					transform: translateY(-50%);
				}
		
				> input {
					padding-left: Constants.$val-spacing-xl;
					padding-right: Constants.$val-spacing-xl;
				}

				&--active {

					> a > [class^="icon-close"] {
						@include icon;
						left: 200px;
						top: 50%;
						transform: translateY(-50%);
					}

					> a > [class^="icon-filter"] {
						@include icon;
						top: 50%;
						transform: translateY(-50%);
					}

					> input {
						padding-left: Constants.$val-spacing-s;
						padding-right: Constants.$val-spacing-xl;
					}
				}
			}
		}


		&__buttons {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			gap: Constants.$val-spacing-s;
		}

	}

	&__extended-filters {
		width: 100%;
	}

}

.row {
	display: flex;
	flex-direction: row;
}

.bulk-filter {
	width: 0px;
}

.specializedFilters {
	display: flex;
	flex-wrap: wrap;
}

.searchInput {
	width: 300px;
	margin-right: Constants.$val-spacing-s;
}